export enum NodeType {
  System = 'System',
  Epi = 'Epi'
}
